import { invokeHttp } from './api'

export const signout = () =>
  invokeHttp('admin/auth/signout', {})

export const signin = (email, password) =>
  invokeHttp('admin/auth/signin', {
    email,
    password,
  })

export const profile = () =>
  invokeHttp('admin/auth/profile', {})
